import {  baseThunk } from '../../fetch/basicThunk';
import { QUERY_GET_CUSTOMERS, QUEY_GET_MASTER_COUNT,QUERY_POST_CREATECUSTOMER, QUERY_POST_UPDATECUSTOMER } from '../../fetch/constantQueries';

export const postCustomerList = baseThunk("customerList/postCustomerList", QUERY_GET_CUSTOMERS, "GET");
export const postCustomerCount = baseThunk("customerList/postCustomerCount",QUEY_GET_MASTER_COUNT,"GET");

export const postCreateCustomer = baseThunk("customers/postCreateCustomer",QUERY_POST_CREATECUSTOMER,"POST");
export const postUpdateCustomer = baseThunk("customers/postUpdateCustomer",QUERY_POST_UPDATECUSTOMER,"POST");